<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist'>
                    <div class="mainSty">
                        <div class="blkm"><img src="@/views/index/image/Avatar2@2x.png" class="img1"></img></div>
                        <div class="blkn">
                            <div class="txt1">{{eng}}</div>
                            <div class="txt2">{{tel}}</div>
                        </div>
                    </div>
                    <div class="q_title">评价应急响应</div>
                    <div :class="{mainSty:true,blko:true,heighth:!isShow}">
                        <div class="blky">
                            <div class="blkt" @click="tselect2">
                                <div>满意</div>
                                <div class="imgk" v-if="active2"><img src="./image/manyi@2x.png" class="imgu"></img></div>
                                <div class="blku" v-else><img src="./image/manyi1@2x.png" class="imgu"></img></div>
                            </div>
                            <div class="blkn" @click="tselect1" style="align-items:center">
                                <div>不满意</div>
                                <div class="blku" v-if="active1"><img src="./image/bumanyi@2x.png" class="imgu"></img></div>
                                <div class="blku" v-else><img src="./image/bumanyi1@2x.png" class="imgu"></img></div>
                            </div>
                        </div>
                        <div v-if="active1" style="margin-bottom:15px;display:flex;flex-direction:row;flex-wrap:wrap">
                            <div @click="cliSty(index,$event)" class="blkc" v-for="(item,index) in estItem" :key="index">
                                <div :class="{active:index==current,e_rect:true}">{{item.value}}</div>
                            </div>
                        </div>
                        <div v-if="active2" style="display:flex;flex-direction:row;flex-wrap:wrap">
                            <div @click="cliSty1(index,$event)" class="blkc" v-for="(item,index) in estItem1" :key="index">
                                <div :class="{active:index==current,e_rect:true}">{{item.value}}</div>
                            </div>
                        </div>
                        <div v-if="isShow" class="blkop">
                            <van-field v-model="message" rows="3" autosize type="textarea" placeholder="请输入" class="inpup" />
                        </div>
                        <div style="width:100%;height:100%;">
                            <div class="blkmn">
                                <!-- <div class="btnlm" @click="toSubmit">提交</div> -->
                                <div class="btnlm">
                                    <button :disabled="disabled" class="btnlm" @click="toSubmit">提交</button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="blker">
                        <div style="flex:1;display:flex;justify-content:center;">
                            <div class="blkbc" @click="toIndex">返回</div>
                        </div>
                    </div>
                </div>
                <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
            </div>
        </div>

    </div>

</template>
<script>
import detailList from "@/components/detailList";
import customToast from "@/components/toast.vue";
export default {
    components: { detailList, customToast },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            disabled: false,
            eng: "",
            tel: "",
            isShow: false,
            current: "",
            active1: true,
            active2: false,
            state: 1,
            message: "态度友好",
            itemList: [],
            estItem: [
                {
                    id: "1",
                    value: "态度友好",
                },
                {
                    id: "2",
                    value: "衣着整洁",
                },
                {
                    id: "3",
                    value: "技术优秀",
                },
                {
                    id: "4",
                    value: "面带微笑",
                },
                {
                    id: "5",
                    value: "其他",
                },
            ],
            estItem1: [
                {
                    id: "1",
                    value: "语言刻薄",
                },
                {
                    id: "2",
                    value: "蓬头垢面",
                },
                {
                    id: "3",
                    value: "效率低下",
                },
                {
                    id: "4",
                    value: "面无表情",
                },
                {
                    id: "5",
                    value: "其他",
                },
            ],
        };
    },
    created() {
        this.getmData();
    },
    methods: {
        cliSty(index, e) {
            this.message = "";
            this.current = index;
            if (index == 4) {
                this.isShow = true;
            } else {
                this.message = this.estItem[index].value;
                this.isShow = false;
            }
        },
        cliSty1(index, e) {
            this.message = "";
            this.current = index;
            if (index == 4) {
                this.isShow = true;
            } else {
                this.message = this.estItem1[index].value;
                this.isShow = false;
            }
        },
        toIndex() {
            if (this.$route.query.froms == 1) {
                this.$router.push("/responseDetail");
            } else {
                this.$router.push("/index");
            }
        },
        getmData() {
            let data = { recordId: this.$route.query.recordId };
            this.$api
                .get("/app/support/getSupportRecordDetailInfo", {
                    params: data,
                })
                .then((res) => {
                    if (res.data.code == "0000") {
                        let data = res.data.data;
                        this.eng = data.engineerName;
                        this.tel = data.engineerTel;
                    }
                });
        },
        getData() {
            this.disabled = true;
            let data = {
                assessBy: this.$store.state.user.userInfo.userId,
                assessContent: this.message,
                assessStatus: this.state,
                recordId: this.$route.query.recordId,
            };
            this.$api.post("/app/assess/supportAssess", data).then((res) => {
                this.disabled = false;
                if (res.data.code == "0000") {
                    // this.$toasts("评价成功");
                    this.toastRow = {
                        selId: 3,
                        title: "评价成功",
                        text: "评价成功",
                    };
                    this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    if (this.$route.query.froms == 1) {
                        setTimeout(() => {
                            this.$router.push("/responseDetail");
                        }, 1000);
                    } else {
                        setTimeout(() => {
                            this.$router.push("/index");
                        }, 1000);
                    }
                }
            });
        },
        toSubmit() {
            this.getData();
        },
        tselect1() {
            this.message = "语言刻薄";
            this.active1 = false;
            this.active2 = true;
            this.state = 0;
        },
        tselect2() {
            this.message = "态度友好";
            this.active2 = false;
            this.active1 = true;
            this.state = 1;
        },
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
.digtxt3 {
    display: flex;
    flex-direction: column;
    align-items: center;
}
button {
    border: none;
    padding: 0;
    margin: 0;
}
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    overflow: auto;
    overflow-x: hidden;
    background: #e9eef2;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 340px;
}
.mainSty {
    width: 303px;
    height: 390x;
    padding: 14px 21px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    display: flex;
    margin-top: 20px;
}
.heighth {
    height: 300px !important;
}
.q_title {
    width: 345px;
    height: 20px;
    margin: 15px auto;
    /* margin:15px 23px; */
    font-size: 14px;
    font-weight: 700;
    color: #222222;
}
.e_rect {
    width: 68px;
    height: 25px;
    line-height: 25px;
    background: #ffffff;
    border: 1px solid #707070;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    margin: 0 auto;
}
.active {
    color: #0080ff;
    border: 1px solid #0080ff;
}

.blkm {
    flex: 0 0 44px;
    font-size: 30px;
}

.img1 {
    width: 44spx;
    height: 44px;
}
.blkn {
    display: flex;
    flex-direction: column;
    justify-content: left;
    flex: 1;
    margin-left: 20px;
}
.txt1 {
    flex: 1;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
}
.txt2 {
    flex: 1;
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    margin-top: 5px;
}
.blko {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 400px;
    margin-top: 20px;
}
/* 	.mtSty{
		margin-bottom:10px;
	} */
.blky {
    display: flex;
    width: 100%;
    height: 84px;
    font-size: 12px;
}
.blku {
    margin-top: 10px;
}
.imgu {
    width: 44px;
    height: 44px;
}
.blkt {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
}
.imgk {
    margin-top: 10px;
}
.blkc {
    flex: 0 0 33.333333%;
    margin-top: 20px;
}
.blkop {
    margin: 20px 15px;
}
.inpup {
    border: 1px solid #0080ff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
}
.blkmn {
    width: 281px;
    height: 44px;
    margin: 30px auto;
}
.btnlm {
    width: 100%;
    height: 100%;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 44px;
    color: #ffffff;
}
.blker {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    margin-bottom: 20px;
}
.blkbc {
    width: 281px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border: 1px solid #0080ff;
    color: #0080ff;
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
}
</style>
